export default function Search() {
    return (
        <svg id="Group_532" data-name="Group 532" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="Path_213" data-name="Path 213" d="M0,0H24V24H0Z" fill="none"/>
            <path id="Path_214" data-name="Path 214" d="M18.031,16.617,22.314,20.9,20.9,22.314l-4.282-4.283a9,9,0,1,1,1.414-1.414Zm-2.006-.742a7,7,0,1,0-.15.15l.15-.15Z" fill="#c6c7d2"/>
            <g id="Group_533" data-name="Group 533" opacity="0">
                <path id="Path_215" data-name="Path 215" d="M0,0H24V24H0Z" fill="none"/>
                <path id="Path_216" data-name="Path 216" d="M18.031,16.617,22.314,20.9,20.9,22.314l-4.282-4.283a9,9,0,1,1,1.414-1.414Z" fill="#1577ea"/>
            </g>
        </svg>
    )
}